import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AuthService, Container, i18n } from '../../../../symphony';

import { ActionType, MainCTAType, RequestType } from '../../global-interface';

import s from './EmptyCodeBits.scss';
import { SlCodeBitsContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';

interface IEmptyCodeBitsProps {
	isSearched: boolean;
	isMyCodeBits: boolean;
}

export function EmptyCodeBits({
	isSearched,
	isMyCodeBits,
}: IEmptyCodeBitsProps) {
	useStyles(s);
	const { pathname, search } = useLocation();
	const isLoggedIn = Container.take('global', AuthService).isLoggedIn();
	const getTitle = () => {
		if (!isLoggedIn && isMyCodeBits) {
			return i18n.t('web-code.login-to-see-codes');
		}

		return i18n.t('web-code.codes-not-found-title');
	};

	const getDescription = () => {
		if (!isLoggedIn && isMyCodeBits) {
			return '';
		}

		if (isSearched) {
			return i18n.t('web-code.codes-not-found-when-searched');
		}

		return i18n.t('web-code.codes-not-found-description');
	};

	const handleEmptyCodeBitsCTAClick = (ctaType: MainCTAType) => {
		const { actions$ } = Container.take(SlCodeBitsContext, SlActions);
		actions$.next({
			type: ActionType.OnEmptyCodeBitsCTAClick,
			requestType: RequestType.Parallel,
			data: {
				ctaType,
				pathname: pathname + search,
			},
		});
	};

	const renderButtons = () => {
		if (isMyCodeBits && !isLoggedIn) {
			return (
				<div className="sl-code-bits-empty__buttons">
					<Button
						buttonType="secondary"
						onClick={() => handleEmptyCodeBitsCTAClick(MainCTAType.SignIn)}
					>
						{i18n.t('web-code.empty-codes-login')}
					</Button>
					<Button
						onClick={() => handleEmptyCodeBitsCTAClick(MainCTAType.SignUp)}
					>
						{i18n.t('web-code.empty-codes-register')}
					</Button>
				</div>
			);
		}

		if (!isSearched && isLoggedIn) {
			return (
				<Button
					onClick={() => handleEmptyCodeBitsCTAClick(MainCTAType.CreateNewCode)}
				>
					{i18n.t('web-code.empty-codes-create-new')}
				</Button>
			);
		}

		return null;
	};

	return (
		<div className="sl-code-bits-empty">
			<div className="sl-code-bits-empty__title">{getTitle()}</div>
			<div className="sl-code-bits-empty__description">
				{getDescription()}
			</div>
			{renderButtons()}
		</div>
	);
}
